'use client';

import { OrganizationLeaveSection } from '../../components/OrganizationProfile/OrganizationGeneralPage';
import { createSection } from '../createSection';

export const OrganizationProfileLeaveSection = createSection(
  'OrganizationProfileLeaveSection',
  OrganizationLeaveSection,
);
